export const CHANGE_STATUS = 'CHANGE_STATUS'
export const CHANGE_MASS_STATUS = 'CHANGE_MASS_STATUS'
export const DETAILS = 'DETAILS'
export const SUPER_ADMIN_DETAILS = 'SUPER_ADMIN_DETAILS'
